import * as React from "react";
import SideBarContainer from "../layouts/sideBar.container";

declare const window: any;

export default function PropertiesContainer({
  data,
  isPortrait,
  setGaleriaSelected,
  setSubMenuSelected,
  subMenuSelectedTemp,
  subMenuSelected,
  setMenuSelected,
  menuSelected,
  theme,
  isSelected,
  setIsSelected,
  icono,
  colors,
  setIsSelectedAttribute,
  setCurrentSelectedAttribute,
  isSelectedAttribute,
  setSelectAvailability,
  selectAvailability,
  setFrame,
  isSideBar,
  setIsSideBar,
  setIsAnimationAttribute,
  hotspotsSelected,
  setHotspotsSelected,
  version
}: any) {
  return (
    <div className={`townplanning-container`}>
      <SideBarContainer
        data={data}
        isPortrait={isPortrait}
        setGaleriaSelected={setGaleriaSelected}
        setSubMenuSelected={setSubMenuSelected}
        subMenuSelectedTemp={subMenuSelectedTemp}
        subMenuSelected={subMenuSelected}
        setMenuSelected={setMenuSelected}
        theme={theme}
        isSideBar={isSideBar}
        setIsSideBar={setIsSideBar}
        menuSelected={menuSelected}
        icono={icono}
        isSelected={isSelected}
        setIsSelected={setIsSelected}
        colors={colors}
        setIsSelectedAttribute={setIsSelectedAttribute}
        setCurrentSelectedAttribute={setCurrentSelectedAttribute}
        isSelectedAttribute={isSelectedAttribute}
        setSelectAvailability={setSelectAvailability}
        selectAvailability={selectAvailability}
        setFrame={setFrame}
        setIsAnimationAttribute={setIsAnimationAttribute}
        hotspotsSelected={hotspotsSelected}
        setHotspotsSelected={setHotspotsSelected}
        version={version}
      />
    </div>
  );
}
